import { Link } from 'edenred-ui';
import styled from 'styled-components';

export const BenefitTypeTileContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  width: 296px;
  margin-bottom: 24px;
  margin-right: 24px;
  padding: 24px;
  background-color: ${props =>
    props.active ? props.theme.primaryBackColorLight10 : props.theme.gray0};
  border: 2px solid;
  border-color: ${props =>
    props.checked ? props.theme.primaryFrontColor : 'transparent'};
  box-shadow: 0 0 0 1px ${props => props.theme.altGray2} inset;
  cursor: ${props => (props.active ? 'auto' : 'pointer')};

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    background-color: ${props =>
      !props.active ? '' : props.theme.primaryBackColorLight10};
    box-shadow: ${props =>
      !props.active
        ? ''
        : `1px 1px 30px 10px ${props.theme.primaryBackColorLight10}`};
  }
`;

export const BenefitTypeStatus = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 12px;
  top: 12px;
  padding: 4px 12px;
  background-color: ${props => props.theme.gray0};
  border-radius: 20px;
`;

export const BenefitTypeStatusText = styled.div`
  color: ${props => props.theme.gray50};
  font-size: ${props => props.theme.sizeExtraSmall};
  line-height: ${props => props.theme.sizeMedium};
  letter-spacing: 0;

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-right: 8px;
    background-color: #42c446;
    border-radius: 100%;
  }
`;

export const BenefitTypeName = styled.div`
  color: ${props => props.theme.primaryFrontColor};
  font-size: ${props => props.theme.sizeExtraExtraLarge};
  font-weight: ${props => props.theme.fontSemiBold};
  margin: ${props => (props.isLunchSelected ? '15px 0 50px' : '15px 0 15px')};
`;

export const CheckboxWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
`;
export const MyChoiceSubtitle = styled.div`
  margin-bottom: 15px;
  color: ${props => props.theme.gray30};
`;

export const StyledLink = styled(Link)`
  color: ${props => props.theme.secondaryFrontColor};
  &:hover {
    color: ${props => props.theme.secondaryFrontColor};
  }
  &:visited {
    color: inherit;
  }
`;
